import { Component, ChangeDetectionStrategy } from "@angular/core";
import { SlotService } from "common/slot.service";
import { WidgetContainerComponent } from "process/view/widget-container.component";
import { BreadcrumbComponent } from "common/breadcrumb/breadcrumb.component";
import { ProcessVersionComponent } from "common/version/process-version.component";
import { ElementNameComponent } from "./element-name.component";
import { SlotDirective } from "common/slot.directive";

import { TranslateModule } from "@ngx-translate/core";

@Component({
	selector: "stages-template-8-4",
	templateUrl: "./template-8-4.component.html",
	providers: [SlotService],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [BreadcrumbComponent, ProcessVersionComponent, ElementNameComponent, SlotDirective, TranslateModule],
})
export class Template84Component extends WidgetContainerComponent {
	constructor() {
		super();
	}
}
